import { type FC } from "react";
import { Field } from "react-final-form";
import { MenuItem, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useWidgetsQuery } from "@/partner/entities/widgets";

const INHERIT_DEFAULT = "";

/**
 * Селект виджета для видео. Пустая опция = «как виджет по умолчанию»
 * (widgetId: null) — по образцу CountryAccessField.
 */
export const WidgetField: FC = () => {
  const { t } = useTranslation();
  const { data } = useWidgetsQuery({
    variables: { page: 0, rowsPerPage: 100 },
  });
  const widgets = data?.widgets.nodes ?? [];

  return (
    <Field name="widgetId">
      {({ input }) => (
        <TextField
          select
          fullWidth
          variant="outlined"
          label={t("widgets.field.label")}
          value={input.value || INHERIT_DEFAULT}
          onChange={(event) => input.onChange(event.target.value || null)}
        >
          <MenuItem value={INHERIT_DEFAULT}>
            {t("widgets.field.inherited")}
          </MenuItem>
          {widgets.map((item) => (
            <MenuItem key={item.id} value={item.id}>
              {item.title}
            </MenuItem>
          ))}
        </TextField>
      )}
    </Field>
  );
};
